import { Navigate } from "react-router-dom";

export default function SPEarnings() {
  return <Navigate to="/revenue-center?view=coach" replace />;
}
